import { useSelector } from 'react-redux';
import { getChannelByUrl } from '../config';
import { salesChannelSelector } from '../_selectors';

export const useIsOktaSSOforPassSubscription = (): boolean => {
    const salesChannelConfig = getChannelByUrl(window.location.host);
    const salesChannelData = useSelector(salesChannelSelector).data;
    const isOktaPass =
        (salesChannelConfig?.sso === 'okta' && salesChannelData?.SalesChannel?.isPass) ||
        salesChannelConfig?.sso === 'ballpark';

    return Boolean(isOktaPass);
};
